import React from "react";
import { useLang } from "../context/LanguageContext";
import { useSettings } from "../context/SettingsContext";
import { Marquee } from "../components/Marquee";
import { fileUrl } from "../lib/api";

const ING = "https://images.unsplash.com/photo-1579113800032-c38bd7635818?auto=format&fit=crop&w=1000&q=80";
const LIFE = "https://images.unsplash.com/photo-1519408824990-bacd0dddb23b?auto=format&fit=crop&w=1000&q=80";
const BUN = "https://images.unsplash.com/photo-1590779033100-9f60a05a013d?auto=format&fit=crop&w=1000&q=80";
const FALLBACKS = [ING, LIFE, BUN];

export const BrandStory = () => {
  const { t, lang } = useLang();
  const { settings } = useSettings();
  const en = {
    p1: "Panda Tata started with a simple craving — a burger that tastes handmade, not machine-made. Every patty is shaped by hand, every bun is fresh-baked in-house daily.",
    p2: "Born in Malaysia and built for a new generation, we mix bold local flavours with a playful, colourful vibe. No shortcuts, no frozen fillers — just honest, stacked-to-order burgers.",
    p3: "From our first small kitchen to a growing family of outlets, our promise stays the same: fresh, handmade, and made with a whole lot of heart.",
  };
  const ms = {
    p1: "Panda Tata bermula dengan satu keinginan mudah — burger yang terasa buatan tangan, bukan mesin. Setiap patti dibentuk dengan tangan, setiap bun dibakar segar setiap hari.",
    p2: "Lahir di Malaysia untuk generasi baharu, kami menggabungkan rasa tempatan yang berani dengan vibe yang ceria dan penuh warna. Tiada jalan pintas, tiada bahan beku.",
    p3: "Dari dapur kecil pertama kami hingga keluarga cawangan yang semakin membesar, janji kami kekal: segar, buatan tangan, dan penuh dengan hati.",
  };
  const def = lang === "ms" ? ms : en;

  const custom = (settings.story_sections || []).filter((s) => s.text_en || s.text_ms || s.image_path);
  const sections = custom.length
    ? custom.map((s, i) => ({
        text: (lang === "ms" ? s.text_ms || s.text_en : s.text_en || s.text_ms) || "",
        img: s.image_path ? fileUrl(s.image_path) : FALLBACKS[i % FALLBACKS.length],
      }))
    : [def.p1, def.p2, def.p3].map((text, i) => ({ text, img: FALLBACKS[i] }));

  return (
    <div>
      <section className="relative overflow-hidden bg-brand-forest text-brand-cream grain">
        <img src="/chewy-bun-badge.png" alt="" className="pointer-events-none absolute right-6 top-10 hidden h-28 w-28 rotate-6 opacity-95 sm:block" />
        <img src="/panda-chef.png" alt="" className="pointer-events-none absolute -bottom-6 left-6 hidden h-32 w-32 -rotate-6 sm:block" />
        <div className="mx-auto max-w-5xl px-5 py-20 text-center">
          <p className="text-sm font-bold uppercase tracking-widest text-brand-green">Panda Tata</p>
          <h1 className="mt-3 font-display text-5xl font-black tracking-tighter text-brand-yellow sm:text-7xl">{t("story_title")}</h1>
          <p className="mx-auto mt-5 max-w-2xl text-lg text-brand-cream/80">{t("brand_slogan")}</p>
        </div>
      </section>
      <Marquee />

      <section className="mx-auto max-w-6xl space-y-16 px-5 py-16" data-testid="brand-story-sections">
        {sections.map((s, i) => {
          const last = i === sections.length - 1;
          const imgRight = i % 2 === 1;
          if (last) {
            return (
              <div key={i} className="rounded-3xl border-2 border-brand-ink bg-brand-green p-8 shadow-brutal-lg sm:p-12" data-testid={`brand-story-item-${i}`}>
                <div className="grid items-center gap-8 lg:grid-cols-2">
                  <p className="font-display text-2xl font-bold leading-snug sm:text-3xl">{s.text}</p>
                  <img src={s.img} alt="" className="aspect-[4/3] w-full rounded-2xl border-2 border-brand-ink object-cover" />
                </div>
              </div>
            );
          }
          return (
            <div key={i} className="grid items-center gap-10 lg:grid-cols-2" data-testid={`brand-story-item-${i}`}>
              <img src={s.img} alt="" className={`aspect-[4/3] w-full rounded-3xl border-2 border-brand-ink object-cover shadow-brutal ${imgRight ? "order-1 lg:order-2" : ""}`} />
              <p className={`font-display text-2xl font-medium leading-snug tracking-tight sm:text-3xl ${imgRight ? "order-2 text-lg leading-relaxed text-brand-ink/80 lg:order-1" : ""}`}>{s.text}</p>
            </div>
          );
        })}
      </section>
    </div>
  );
};

export default BrandStory;
